import * as React from 'react';
import classNames from 'classnames';
import {Flex, CurrencyDisplayType} from 'components/UIKit';
import {ListingMetric as ListingMetricType} from '../../types';
import styles from './ListingMetrics.scss';
import {ListingMetric} from './components';

export interface ListingMetricsProps {
  metrics: ListingMetricType[];
  className?: string;
  condensed?: boolean;
  hideWarnings?: boolean;
  showVerified?: boolean;
  currencyDisplay?: CurrencyDisplayType;
}

export function ListingMetrics({
  metrics = [],
  className = '',
  condensed = false,
  hideWarnings = false,
  showVerified = false,
  currencyDisplay = 'subhead',
}: ListingMetricsProps) {
  return (
    <Flex
      wrap="wrap"
      className={classNames(styles.Container, className, {
        [styles.Condensed]: condensed,
      })}
      wrapperComponent="ul"
      justifyContent="space-between"
    >
      {metrics.map((metric) => (
        <ListingMetric
          key={metric.title}
          metric={metric}
          condensed={condensed}
          hideWarning={hideWarnings}
          showVerified={showVerified}
          currencyDisplay={currencyDisplay}
        />
      ))}
    </Flex>
  );
}

export default ListingMetrics;
